export function offsetRelativeToBody(el: HTMLElement) {
    const result = {
        top: el.offsetTop,
        left: el.offsetLeft,
    };
    let curr = el.offsetParent as HTMLElement;
    while (curr != null && curr.tagName != "BODY") {
        result.top += curr.offsetTop;
        result.left += curr.offsetLeft;

        curr = curr.offsetParent as HTMLElement;
    }
    return result;
}

export function getPagePosition(el: HTMLElement) {
    const offset = offsetRelativeToBody(el);
    return {
        ...offset,
        width: el.offsetWidth,
        height: el.offsetHeight,
        bottom: offset.top + el.offsetHeight,
        right: offset.left + el.offsetWidth,
    }
}